import {BASE_PARAMS} from '../config'
import {getENV} from '../utils'

/**
 * 上传文件ajax
 *
 * */
export default function (file, options) {
    let env = getENV();
    let form = new FormData()
    for (let item in BASE_PARAMS) {
        form.append(item, BASE_PARAMS[item])
    }

    for (let key in options) {
        if (typeof options[key] !== 'function' || typeof options[key] !== 'object') {
            form.append(key, options[key])
        }
    }

    form.append('file', file)
    form.append('service', 'smarthos.system.file.upload')
    Log('请求', form)

    let promiseXHR = new Promise((resolve, reject) => {
        let xhr = new XMLHttpRequest()
        xhr.open('POST', env.upload)
        xhr.setRequestHeader('sign', 'test')
        xhr.onerror = function (error) {
            Log('error', error)
            reject(error)
        }
        xhr.onreadystatechange = function () {
            Log('readyState', xhr.readyState)
            if (xhr.readyState == 4) {
                if (xhr.status == 200) {
                    Log('响应', xhr.responseText)
                    resolve(JSON.parse(xhr.responseText))
                } else {
                    Log('status', xhr.status)
                }
            }
        }
        xhr.send(form)
    })
    return promiseXHR
}
